/**
 * Ícones de linha (lucide) no lugar de emojis.
 *
 * <Ico e="📋" />  → ícone fixo no JSX
 * emo(valor)      → renderiza uma string trocando os emojis conhecidos por ícones;
 *                   qualquer outro valor (número, elemento, array) passa intacto.
 * Os dados continuam sendo strings; só a renderização muda.
 */
import React from 'react';
import {
  ClipboardList, AlertTriangle, X, CheckCircle2, Pencil, Save, MessageCircle, Building2, FileText,
  Check, Salad, Scale, Dumbbell, Calendar, Hourglass, Sparkles, Activity, UtensilsCrossed, Plus,
  Trash2, TrendingUp, Flame, RefreshCw, Pill, File, Bot, Target, Search, Droplet, BarChart3, Printer,
  User, Stethoscope, Paperclip, Leaf, Laptop, Beef, Settings, Users, Microscope, Moon, Heart, Upload,
  Lock, Flower2, Wheat, Wallet, AlertCircle, Droplets, Mail, Inbox, Star, Zap, Eye, XCircle,
  Smartphone, Ban, Camera, FlaskConical, Lightbulb, Sprout, Clock, Link, Utensils, Ruler, MapPin,
  ArrowDown, ArrowUp, ArrowRight, CheckSquare, Egg, Apple, Milk, Globe, Cloud, Smile, Cake, Sun,
  Frown, Calculator, Candy, Timer, Unlock, Square, FolderOpen, Image, Banknote, PieChart, Drumstick,
  Bean, CupSoda, Shuffle, PartyPopper, Rocket, BookOpen, Plug, CalendarDays,
  Send, Bell, Info, HelpCircle, Gift, Phone, Video, Home, LogOut, Filter, Copy, Share2,
  ChevronRight, ChevronLeft, ShieldCheck, Key, Tag, Award, Coffee, Soup, Carrot, Fish,
  Baby, Brain, HeartPulse, Weight, Footprints, Bike, Bed, ThumbsUp, Wand2, ListChecks, History,
} from 'lucide-react';

export const EMOJI_ICONS = {
  '📋': ClipboardList, '⚠': AlertTriangle, '✕': X, '✖': X, '✅': CheckCircle2, '✏': Pencil, '💾': Save,
  '💬': MessageCircle, '🏥': Building2, '📝': FileText, '✓': Check, '✔': Check, '🥗': Salad, '⚖': Scale,
  '💪': Dumbbell, '📅': Calendar, '📆': CalendarDays, '🗓': CalendarDays, '⏳': Hourglass, '⌛': Hourglass,
  '✨': Sparkles, '🏃': Activity, '🍽': UtensilsCrossed, '➕': Plus, '🗑': Trash2, '📈': TrendingUp,
  '📉': TrendingUp, '🔥': Flame, '🔄': RefreshCw, '🔁': RefreshCw, '💊': Pill, '📄': File, '📃': File,
  '🤖': Bot, '🎯': Target, '🔍': Search, '🔎': Search, '💧': Droplet, '📊': BarChart3, '🖨': Printer,
  '👤': User, '👩': User, '👨': User, '👧': User, '👴': User, '👵': User, '🧑': User, '👩‍⚕': Stethoscope,
  '🩺': Stethoscope, '⚕': Stethoscope, '📎': Paperclip, '🥑': Leaf, '💻': Laptop, '🥩': Beef,
  '⚙': Settings, '👥': Users, '🔬': Microscope, '😴': Moon, '🌙': Moon, '❤': Heart, '💛': Heart,
  '🤍': Heart, '💚': Heart, '💜': Heart, '📤': Upload, '🔒': Lock, '🔐': Lock, '🌸': Flower2,
  '🌾': Wheat, '🍚': Wheat, '💰': Wallet, '💵': Banknote, '💸': Banknote, '🔴': AlertCircle,
  '🟢': CheckCircle2, '🟡': AlertCircle, '🚽': Droplets, '📧': Mail, '✉': Mail, '📬': Mail, '📩': Mail,
  '📥': Inbox, '⭐': Star, '🌟': Star, '⚡': Zap, '👁': Eye, '👀': Eye, '❌': XCircle, '📱': Smartphone,
  '📲': Smartphone, '🚫': Ban, '📸': Camera, '📷': Camera, '🧪': FlaskConical, '💡': Lightbulb,
  '🌿': Leaf, '🍃': Leaf, '🫛': Leaf, '🥦': Carrot, '🥕': Carrot, '🌱': Sprout, '🕐': Clock, '⏰': Clock,
  '⏱': Timer, '🔗': Link, '🍴': Utensils, '📐': Ruler, '📏': Ruler, '🤏': Ruler, '📍': MapPin,
  '⬇': ArrowDown, '⬆': ArrowUp, '➡': ArrowRight, '☑': CheckSquare, '☐': Square, '🥚': Egg, '🍎': Apple,
  '🍏': Apple, '🥛': Milk, '🌐': Globe, '☁': Cloud, '😊': Smile, '🙂': Smile, '😕': Frown, '🎂': Cake,
  '☀': Sun, '🧮': Calculator, '🍬': Candy, '🦋': Sparkles, '🔮': Sparkles, '🩸': Droplet, '🔓': Unlock,
  '📂': FolderOpen, '📁': FolderOpen, '🖼': Image, '🥧': PieChart, '🍗': Drumstick, '🫘': Bean,
  '🥤': CupSoda, '🔀': Shuffle, '🎉': PartyPopper, '🚀': Rocket, '📓': BookOpen, '📒': BookOpen,
  '🔌': Plug, '📦': Inbox, '⬇️': ArrowDown, '🔔': Bell, 'ℹ': Info, '❓': HelpCircle, '🎁': Gift,
  '📞': Phone, '☎': Phone, '🎥': Video, '📹': Video, '🏠': Home, '🚪': LogOut, '🧹': Filter,
  '📑': Copy, '🔃': RefreshCw, '↗': Share2, '▶': ChevronRight, '◀': ChevronLeft, '⏩': ChevronRight,
  '🛡': ShieldCheck, '🔑': Key, '🏷': Tag, '🏆': Award, '🥇': Award, '☕': Coffee, '🍲': Soup,
  '🐟': Fish, '👶': Baby, '🧠': Brain, '💓': HeartPulse, '🫀': HeartPulse, '🏋': Weight, '👣': Footprints,
  '🚴': Bike, '🛏': Bed, '👍': ThumbsUp, '🪄': Wand2, '🗂': ListChecks, '🕓': History, '📊️': BarChart3,
  '📌': MapPin, '🧾': FileText, '🖊': Pencil, '📨': Send, '🔙': ChevronLeft, '🔧': Settings,
  '🛠': Settings, '♻': RefreshCw, '🆕': Sparkles, '🧘': Activity, '🤰': Baby, '💤': Moon, '⏸': Timer,
  '🍳': Egg, '🍞': Wheat, '🥜': Bean, '🫒': Leaf, '🍌': Apple, '🍓': Apple, '🥝': Apple, '🧀': Milk,
  '🍫': Candy, '🍷': CupSoda, '🍺': CupSoda, '🚬': Ban, '🏊': Activity, '⚽': Activity, '🎨': Sparkles,
  '📚': BookOpen, '🖥': Laptop, '⌨': Laptop, '🧴': Droplets, '🫗': Droplets, '🌡': Activity,
  '👁‍🗨': Eye, '💁': Info, '🙋': HelpCircle, '✍': Pencil, '⤴': ArrowUp, '⤵': ArrowDown, '🔻': ArrowDown,
  '🔺': ArrowUp, '🍰': Cake, '🥣': Soup, '🌮': Utensils, '🍱': UtensilsCrossed, '⚖️': Scale,
  '📭': Inbox, '📮': Mail, '📇': ClipboardList, '🗒': BookOpen, '⏲': Timer, '🔋': Zap, '💯': Award,
  '🎓': Award, '📣': Bell, '📢': Bell, '🏁': Target, '⛔': Ban, '🆘': AlertTriangle, '❗': AlertCircle,
  '❕': AlertCircle, '‼': AlertCircle, '⁉': HelpCircle, '❔': HelpCircle, '🔵': Info, '🟠': AlertCircle,
  '🟣': Info, '⚪': Square, '⚫': Square, '🔘': Square, '🗝': Key, '🛒': Inbox, '📶': BarChart3,
  '🧬': Microscope, '🦠': Microscope, '🩻': Microscope, '🩹': Stethoscope, '💉': Pill,
  '🍵': Coffee, '🧃': CupSoda, '🍹': CupSoda, '🥥': Apple, '🍑': Apple, '🍉': Apple, '🍇': Apple,
  '🍊': Apple, '🍋': Apple, '🍒': Apple, '🥭': Apple, '🍍': Apple, '🍐': Apple, '🥒': Carrot,
  '🍅': Apple, '🌽': Wheat, '🥔': Carrot, '🍠': Carrot, '🥬': Leaf, '🧄': Leaf, '🧅': Leaf,
  '🍄': Leaf, '🥐': Wheat, '🥖': Wheat, '🥨': Wheat, '🥯': Wheat, '🥞': Wheat, '🧇': Wheat,
  '🍝': Soup, '🍜': Soup, '🍛': Soup, '🍣': Fish, '🍤': Fish, '🦐': Fish, '🥓': Beef, '🍖': Drumstick,
  '🍔': Utensils, '🍟': Utensils, '🍕': Utensils, '🌭': Utensils, '🥪': Utensils, '🌯': Utensils,
  '🥙': Utensils, '🧆': Utensils, '🥘': Soup, '🫕': Soup, '🥫': Soup, '🍿': Candy, '🍩': Candy,
  '🍪': Candy, '🍦': Candy, '🍨': Candy, '🍧': Candy, '🧁': Cake, '🥮': Cake, '🍮': Cake, '🍯': Candy,
  '🧈': Milk, '🧂': Leaf, '🫖': Coffee, '🧊': Droplet, '🥂': CupSoda, '🍸': CupSoda, '🍾': CupSoda,
  '🥃': CupSoda, '🧉': Coffee, '🍶': CupSoda, '🫙': Droplets, '🚨': AlertTriangle, '🫚': Leaf,
};

// Emoji (com variação/ZWJ opcionais) — mesmo critério usado na migração.
const EMOJI_RE = /([\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{231A}-\u{23FF}\u{2139}\u{203C}\u{2049}](?:‍[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}])*)️?/gu;

const base = (c) => c.replace(/️/g, '');

export function Ico({ e, size = '1em', sp = false, style, ...rest }) {
  const Cmp = EMOJI_ICONS[base(e)] || EMOJI_ICONS[base(e).replace(/‍.*/, '')];
  if (!Cmp) return <>{e}{sp ? ' ' : ''}</>;
  return (
    <Cmp
      size={size}
      strokeWidth={1.75}
      aria-hidden="true"
      style={{ verticalAlign: '-0.14em', flexShrink: 0, marginRight: sp ? '0.4em' : 0, ...style }}
      {...rest}
    />
  );
}

export function emo(value) {
  if (typeof value !== 'string' || !value) return value;
  EMOJI_RE.lastIndex = 0;
  if (!EMOJI_RE.test(value)) return value;
  EMOJI_RE.lastIndex = 0;
  const out = [];
  let last = 0, m, k = 0;
  while ((m = EMOJI_RE.exec(value))) {
    if (m.index > last) out.push(value.slice(last, m.index));
    const next = value[m.index + m[0].length];
    const sp = next === ' ';
    out.push(<Ico key={k++} e={m[1]} sp={sp && m.index + m[0].length + 1 < value.length} />);
    last = m.index + m[0].length + (sp ? 1 : 0);
  }
  if (last < value.length) out.push(value.slice(last));
  return out;
}

/** Versão só-texto (para <option>, title, etc.): remove os emojis. */
export function noEmo(value) {
  if (typeof value !== 'string') return value;
  return value.replace(new RegExp(EMOJI_RE.source + ' ?', 'gu'), '');
}

export default Ico;
